import XXH from 'xxhashjs';

function calculateHash(data) {
    return XXH.h32(JSON.stringify(data), 0xABCD).toString(16);
}

export default calculateHash;
